document.addEventListener("DOMContentLoaded", async function () {

  async function getAvailableDeliveryCards(handle) {
    if (!handle) return [];
    try {
      const res = await fetch(`/products/${handle}`);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, "text/html");
      return [...doc.querySelectorAll(".delivery-card")]
        .map((card) => ({
          variantId: card.dataset.variantId,
          productId: card.dataset.productId,
          price: card.dataset.variantPrice,
          name: card.dataset.variantName,
        }))
        .filter((c) => c.variantId);
    } catch (err) {
      console.error("Failed to fetch delivery cards for product:", handle, err);
      return [];
    }
  }

  const CUSTOM_TOP_LEAD_TIME_BASE_NAMES = [
    "Deluxe Ply Edge",
    "Scallop Top",
    "Wave Desktop",
  ];

  const LEAD_TIME_ACCESSORIES = [
    "Deluxe Ply Edge",
    "2 X  Deluxe Ply Edge",
    "Scallop Top",
    "2 X Scallop Top",
    "2 X Wave Desktop",
    "Wave Desktop",
  ];

  const RESTRICTED_COLOURS = [
    "Black",
    "Dark Grey",
    "Maple",
    "Golden Maple",
    "Slate Dark Grey",
    "Midnight Black",
  ];

  const RESTRICTED_SIZES = [
    "160x80",
    "180x80",
    "160x80cm",
    "180x80cm",
    "160x80 + 60x80",
    "180x80 + 60x80",
    "160x80cm + 60x80",
    "180x80cm + 60x80",
  ];

  function isCustomTopBaseAccessory(name) {
    const n = (name || "").toLowerCase();
    return CUSTOM_TOP_LEAD_TIME_BASE_NAMES.some((base) =>
      n.includes(base.toLowerCase())
    );
  }

  function isDesktopRestricted(mainItem) {
    const deskTopSize =
      mainItem.options_with_values?.find(
        (o) => o.name === "Desk Top Size(cm)"
      )?.value || "";
    const deskTopColour =
      mainItem.options_with_values?.find(
        (o) => o.name === "Desk Top Colour"
      )?.value || "";
    return (
      RESTRICTED_SIZES.includes(deskTopSize) &&
      RESTRICTED_COLOURS.includes(deskTopColour)
    );
  }

  function isAirflowRestricted(mainItem) {
    const handle = (mainItem.handle || "").toLowerCase();
    const isAirflowProduct = handle.includes("airflow-ergonomic-task-chair");
    if (!isAirflowProduct) return false;
    const colour =
      mainItem.options_with_values?.find(
        (o) => o.name === "Colour" || o.name === "Color"
      )?.value || "";
    return colour.trim().toLowerCase() === "black";
  }

  function anyRemainingAccessoryNeedsLeadTime(variantNames) {
    return variantNames.some((name) =>
      LEAD_TIME_ACCESSORIES.some((acc) =>
        (name || "").toLowerCase().includes(acc.toLowerCase())
      )
    );
  }

  const ORDER_VALUE_THRESHOLD = 15000;

  function isOrderValueName(name) {
    const n = (name || "").toLowerCase();
    return n.includes("order value") && n.includes("15000");
  }

  function isDeliveryLineName(name) {
    const n = (name || "").toLowerCase();
    return n.includes("delivery") || n.includes("installation") || isOrderValueName(n);
  }

  function computeOrderValueTotal(cartData, accessoryGroupId) {
    return (
      cartData.items
        .filter(
          (i) =>
            i.properties && i.properties._accessoryGroupId === accessoryGroupId
        )
        .filter((i) => !isDeliveryLineName(i.variant_title || i.product_title))
        .reduce((sum, i) => sum + (i.line_price || 0), 0) / 100
    );
  }

  async function resolveDefaultDelivery(mainItem) {
    const mainProductPrice = parseFloat(mainItem.price || 0) / 100;

    let desiredVariantId = "57642286317955";
    let desiredName = "Delivery Options : FREE Delivery";
    let desiredProductId = "15839611978115";
    let desiredPrice = "0";

    if (mainProductPrice <= 75) {
      desiredVariantId = "58006245278083";
      desiredName = "Delivery Options : Standard Delivery";
      desiredPrice = "9.95";
    } else if (isAirflowRestricted(mainItem)) {
      desiredVariantId = "62695256850819";
      desiredName = "FREE Delivery (3 week lead time)";
      desiredPrice = "0";
    }

    let finalVariantId = desiredVariantId;
    let finalName = desiredName;
    let finalProductId = desiredProductId;
    let finalPrice = desiredPrice;

    const availableCards = (await getAvailableDeliveryCards(mainItem.handle)).filter(
      (c) => !isOrderValueName(c.name)
    );

    if (availableCards.length) {
      const matchedCard = availableCards.find(
        (c) => String(c.variantId) === String(desiredVariantId)
      );
      const chosenCard =
        matchedCard ||
        availableCards.find((c) => Number(c.price) === 0) ||
        availableCards[0];

      finalVariantId = chosenCard.variantId;
      finalName = chosenCard.name || desiredName;
      finalProductId = chosenCard.productId || desiredProductId;
      finalPrice = chosenCard.price || desiredPrice;
    }

    return {
      variantId: finalVariantId,
      name: finalName,
      productId: finalProductId,
      price: finalPrice,
    };
  }

  async function downgradeLeadTimeDeliveryIfNoLongerNeeded({
    cartData, mainItem, accessoryGroupId, variantNames, variantIds, productIds, prices,
  }) {
    if (isDesktopRestricted(mainItem)) return;
    if (anyRemainingAccessoryNeedsLeadTime(variantNames)) return;

    const deliveryIndex = variantNames.findIndex((n) => isDeliveryLineName(n));
    if (deliveryIndex === -1) return;

    const currentDeliveryName = (variantNames[deliveryIndex] || "").toLowerCase();
    if (!currentDeliveryName.includes("4 week")) return;

    const oldDeliveryVariantId = variantIds[deliveryIndex];

    const deliveryCartItem = cartData.items.find(
      (i) =>
        i.properties &&
        !i.properties._accessoryVariantIds &&
        i.properties._accessoryGroupId === accessoryGroupId &&
        String(i.variant_id) === String(oldDeliveryVariantId)
    );

    const newDelivery = await resolveDefaultDelivery(mainItem);

    variantNames[deliveryIndex] = newDelivery.name;
    variantIds[deliveryIndex] = newDelivery.variantId;
    productIds[deliveryIndex] = newDelivery.productId;
    prices[deliveryIndex] = newDelivery.price;

    if (deliveryCartItem) {
      await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: deliveryCartItem.key, quantity: 0 }),
      });
    }

    await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: newDelivery.variantId,
        quantity: mainItem.quantity,
        properties: { _accessoryGroupId: accessoryGroupId },
      }),
    });
  }

  async function downgradeOrderValueIfNoLongerEligible({
    cartData, mainItem, accessoryGroupId, variantNames, variantIds, productIds, prices,
  }) {
    const deliveryIndex = variantNames.findIndex((n) => isDeliveryLineName(n));
    if (deliveryIndex === -1) return;
    if (!isOrderValueName(variantNames[deliveryIndex])) return;

    const total = computeOrderValueTotal(cartData, accessoryGroupId);
    if (total >= ORDER_VALUE_THRESHOLD) return;

    const oldDeliveryVariantId = variantIds[deliveryIndex];

    const deliveryCartItem = cartData.items.find(
      (i) =>
        i.properties &&
        !i.properties._accessoryVariantIds &&
        i.properties._accessoryGroupId === accessoryGroupId &&
        String(i.variant_id) === String(oldDeliveryVariantId)
    );

    const newDelivery = await resolveDefaultDelivery(mainItem);

    variantNames[deliveryIndex] = newDelivery.name;
    variantIds[deliveryIndex] = newDelivery.variantId;
    productIds[deliveryIndex] = newDelivery.productId;
    prices[deliveryIndex] = newDelivery.price;

    if (deliveryCartItem) {
      await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: deliveryCartItem.key, quantity: 0 }),
      });
    }

    await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: newDelivery.variantId,
        quantity: mainItem.quantity,
        properties: { _accessoryGroupId: accessoryGroupId },
      }),
    });
  }

  async function updateDeliveryRemoveButtons() {
    const cartDataJson = document.getElementById("cart_data_json");
    const cartData = cartDataJson ? JSON.parse(cartDataJson.textContent) : null;
    if (!cartData || !cartData.items) return;

    const mainItems = cartData.items.filter(
      (i) => i.properties && i.properties._accessoryVariantIds
    );

    for (const mainItem of mainItems) {
      const groupId = mainItem.properties._accessoryGroupId;

      const deliverySubItem = cartData.items.find(
        (i) =>
          i.properties &&
          !i.properties._accessoryVariantIds &&
          i.properties._accessoryGroupId === groupId &&
          isDeliveryLineName(i.variant_title || i.product_title)
      );

      if (!deliverySubItem) continue;

      const availableCards = await getAvailableDeliveryCards(mainItem.handle);
      if (!availableCards.length) continue;

      const firstCardVariantId = availableCards[0].variantId;
      const isDefaultCard =
        String(deliverySubItem.variant_id) === String(firstCardVariantId);

      const removeEl = document.querySelector(
        `.remove-btn[data-key="${deliverySubItem.key}"]`
      );

      if (removeEl) {
        removeEl.style.display = isDefaultCard ? "none" : "";
      }
    }
  }

  window.updateDeliveryRemoveButtons = updateDeliveryRemoveButtons;

  const drawer = document.getElementById("CartDrawer");
  const overlay = document.getElementById("CartOverlay");
  const cartItemsContainer = document.getElementById("CartItems");
  const cartTotal = document.getElementById("CartTotal");

  function showSubProducts() {
    const cartItems = document.querySelectorAll('.yyd_custom_cart_drawer #CartDrawer #CartItems > .cart-item');
    cartItems.forEach((cartItem) => {
      const subProducts = cartItem.querySelectorAll('.cart_sub_product .cart-item');
      if (subProducts.length > 0) {
        const showSubProductBtn = cartItem.querySelector('.sub_products');
        if (showSubProductBtn) {
          showSubProductBtn.style.display = 'flex';
        }
      }
    });
  }

  window.showSubProducts = showSubProducts;

  document.addEventListener("click", function (e) {
    const subProductsBtn = e.target.closest(".sub_products");
    if (!subProductsBtn) return;

    if (!subProductsBtn.dataset.originalText) {
      subProductsBtn.dataset.originalText = subProductsBtn.textContent.trim();
    }

    subProductsBtn.classList.toggle("is_active");

    if (subProductsBtn.classList.contains("is_active")) {
      subProductsBtn.textContent = "Hide Accessories";
    } else {
      subProductsBtn.textContent = subProductsBtn.dataset.originalText;
    }

    const subProductItemId = subProductsBtn.getAttribute("data-sub-products-id");
    const subProductListEl = document.querySelector(
      `.cart_sub_product[data-sub-products-list="${subProductItemId}"]`
    );

    if (subProductListEl) {
      subProductListEl.classList.toggle("is_active");
      setTimeout(() => {
        subProductListEl.style.display = subProductsBtn.classList.contains("is_active")
          ? "block"
          : "none";
      }, 300);
    }
  });

  /* =====================================
     REMOVE ITEM
  ===================================== */
  document.addEventListener("click", async function (e) {
    const removeBtn = e.target.closest(".remove-btn");
    if (!removeBtn) return;

    const cartItemEl = removeBtn.closest(".cart-item");
    if (cartItemEl) cartItemEl.classList.add("loading");

    try {
      const cartDataJson = document.getElementById("cart_data_json");
      let cartData = cartDataJson ? JSON.parse(cartDataJson.textContent) : null;

      const key = removeBtn.getAttribute("data-key");
      if (!key) return;

      const prodType = removeBtn.getAttribute("data-prod-type");
      let subItemsToRemove = [];
      let mainItem = null;

      const currentItem = cartData?.items?.find((item) => item.key === key);
      const accessoryGroupId = currentItem?.properties?._accessoryGroupId;

      if (prodType === "sub" && cartData) {
        const variantId = String(currentItem.variant_id);
        const productId = String(currentItem.product_id);
        const variantPrice = String(currentItem.line_price);

        mainItem = cartData.items.find(
          (item) =>
            item.properties &&
            item.properties._accessoryGroupId === accessoryGroupId &&
            item.properties._accessoryVariantNames,
        );

        if (!mainItem) return;

        let variantNames = mainItem.properties._accessoryVariantNames.split(",");
        let variantIds = mainItem.properties._accessoryVariantIds.split(",");
        let productIds = mainItem.properties._accessoryProductIds.split(",");
        let prices = mainItem.properties._accessoryVariantPrices.split(",");

        const removeIndex = variantIds.findIndex(
          (id, i) =>
            id === variantId ||
            productIds[i] === productId ||
            prices[i] === variantPrice,
        );

        if (removeIndex === -1) return;

        const variantNameToRemove = variantNames[removeIndex];
        const isDeliveryOption = isDeliveryLineName(variantNameToRemove);

        variantNames.splice(removeIndex, 1);
        variantIds.splice(removeIndex, 1);
        productIds.splice(removeIndex, 1);
        prices.splice(removeIndex, 1);

        if (isDeliveryOption) {
          const mainProductPrice = parseFloat(mainItem.price || 0) / 100;

          let desiredVariantId = "57642286317955";
          let desiredName = "Delivery Options : FREE Delivery";
          let desiredProductId = "15839611978115";
          let desiredPrice = "0";

          if (mainProductPrice <= 75) {
            desiredVariantId = "58006245278083";
            desiredName = "Delivery Options : Standard Delivery";
            desiredPrice = "9.95";
          } else if (isAirflowRestricted(mainItem)) {
            desiredVariantId = "62695256850819";
            desiredName = "FREE Delivery (3 week lead time)";
            desiredPrice = "0";
          } else {
            const desktopRestricted = isDesktopRestricted(mainItem);
            const accessoryBasedRestricted = anyRemainingAccessoryNeedsLeadTime(variantNames);
            const shouldAddLeadTime = desktopRestricted || accessoryBasedRestricted;
            if (shouldAddLeadTime) {
              desiredVariantId = "58097161961859";
              desiredName = "FREE Delivery (4 week lead time)";
              desiredPrice = "0";
            }
          }

          let finalVariantId = desiredVariantId;
          let finalName = desiredName;
          let finalProductId = desiredProductId;
          let finalPrice = desiredPrice;

          const availableCards = (await getAvailableDeliveryCards(mainItem.handle)).filter(
            (c) => !isOrderValueName(c.name)
          );

          // if (availableCards.length) {
          //   const matchedCard = availableCards.find(
          //     (c) => String(c.variantId) === String(desiredVariantId)
          //   );
          //   const chosenCard =
          //     matchedCard ||
          //     availableCards.find((c) => Number(c.price) === 0) ||
          //     availableCards[0];

          //   finalVariantId = chosenCard.variantId;
          //   finalName = chosenCard.name || desiredName;
          //   finalProductId = chosenCard.productId || desiredProductId;
          //   finalPrice = chosenCard.price || desiredPrice;
          // }
           if (availableCards.length) {
              const removedCarePlusFourWeek =
                /care\+/i.test(variantNameToRemove) &&
                /installation/i.test(variantNameToRemove) &&
                /4\s*week/i.test(variantNameToRemove);

              const preferredReplacementCard = removedCarePlusFourWeek
                ? availableCards.find((c) => {
                    const name = (c.name || "").toLowerCase();
                    return (
                      name.includes("expert installation") &&
                      /4\s*week/.test(name)
                    );
                  })
                : null;

              const matchedCard = availableCards.find(
                (c) => String(c.variantId) === String(desiredVariantId)
              );

              const chosenCard =
                preferredReplacementCard ||
                matchedCard ||
                availableCards.find((c) => Number(c.price) === 0) ||
                availableCards[0];

              console.log("[YY Delivery Replacement]", {
                removedDelivery: variantNameToRemove,
                carePlusFourWeekRemoved: removedCarePlusFourWeek,
                replacementSelected: chosenCard.name,
                replacementVariantId: chosenCard.variantId
              });

              finalVariantId = chosenCard.variantId;
              finalName = chosenCard.name || desiredName;
              finalProductId = chosenCard.productId || desiredProductId;
              finalPrice = chosenCard.price || desiredPrice;
            }

          variantNames.push(finalName);
          variantIds.push(finalVariantId);
          productIds.push(finalProductId);
          prices.push(finalPrice);

          await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              id: finalVariantId,
              quantity: mainItem.quantity,
              properties: { _accessoryGroupId: accessoryGroupId },
            }),
          });
        } else if (isCustomTopBaseAccessory(variantNameToRemove)) {
          await downgradeLeadTimeDeliveryIfNoLongerNeeded({
            cartData, mainItem, accessoryGroupId, variantNames, variantIds, productIds, prices,
          });
        }

        await downgradeOrderValueIfNoLongerEligible({
          cartData, mainItem, accessoryGroupId, variantNames, variantIds, productIds, prices,
        });

        mainItem.properties._accessoryVariantNames = variantNames.join(",");
        mainItem.properties._accessoryVariantIds = variantIds.join(",");
        mainItem.properties._accessoryProductIds = productIds.join(",");
        mainItem.properties._accessoryVariantPrices = prices.join(",");

        if (variantNameToRemove in mainItem.properties) {
          mainItem.properties[variantNameToRemove] = "";
        }
      }

      if (prodType === "main") {
        subItemsToRemove = cartData.items.filter(
          (item) =>
            item.properties &&
            !item.properties._accessoryVariantIds &&
            item.properties._accessoryGroupId === accessoryGroupId,
        );
      }

      await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: key, quantity: 0 }),
      });

      if (prodType === "sub" && mainItem) {
        await fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id: mainItem.key,
            quantity: mainItem.quantity,
            properties: mainItem.properties,
          }),
        });
      }

      if (prodType === "main" && subItemsToRemove.length) {
        const formData = new FormData();
        subItemsToRemove.forEach((subItem) => {
          formData.append(`updates[${subItem.key}]`, 0);
        });
        await fetch("/cart/update.js", {
          method: "POST",
          headers: {
            "Accept": "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: formData,
        });
      }

      setTimeout(async () => {
        await updateCart();
      }, 400);

    } catch (err) {
      console.error("Remove error:", err);
    } finally {
      if (cartItemEl) cartItemEl.classList.remove("loading");
    }
  });

  /* =====================================
     OPEN DRAWER
  ===================================== */
  document.querySelectorAll('.js-cart-icon, .js-drawer-open-right, .js-cart-mobile-icon').forEach(btn => {
    btn.addEventListener("click", async function (e) {
      e.preventDefault();
      await updateCart();
      drawer?.classList.remove("active", "is-active");
      overlay?.classList.remove("active", "is-active");
      drawer?.classList.add("active", "is-active");
      overlay?.classList.add("active", "is-active");
    });
  });

  /* =====================================
     CLOSE DRAWER
  ===================================== */
  function closeCartDrawer() {
    drawer?.classList.remove("active", "is-active");
    overlay?.classList.remove("active", "is-active");
    document.body.style.removeProperty("overflow");
  }

  overlay?.addEventListener("click", function () {
    closeCartDrawer();
  });

  document.addEventListener("click", function (e) {
    if (e.target.closest("#closeCart")) {
      closeCartDrawer();
    }
  });

  /* =====================================
     UPDATE CART
     ─ Now accepts skipQtyEnforce flag.
     ─ When called normally (no flag), it runs
       enforceLimitedVariant() IN THE SAME PASS
       by awaiting it BEFORE resolving, then
       re-renders only once with corrected quantities.
     ─ enforceLimitedVariant() passes skipCartReload=true
       so it never triggers a second updateCart().
  ===================================== */
  async function updateCart(skipQtyEnforce = false) {

    const drawerEl = document.querySelector('.yyd_custom_cart_drawer');
    const currentCartItems = document.getElementById('CartItems');
    currentCartItems.innerHTML = '';

    if (!drawerEl) return;

    // ── STEP 1: if quantity enforcement is needed, do it FIRST
    //   against the live cart BEFORE re-rendering the drawer.
    //   This means quantities are already correct when the HTML
    //   section is fetched, so the drawer renders right first time.
    if (!skipQtyEnforce) {
      await enforceLimitedVariant('pre-render inside updateCart', true);
    }

    // ── STEP 2: now fetch the section HTML (quantities are already correct)
    const originalId = drawerEl.id;
    const updatedId = originalId.replace('shopify-section-', '');

    fetch(`/?section_id=${updatedId}`)
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        const cartItems = doc.querySelector('#CartItems');
        const cartFooter = doc.querySelector('.cart-footer');
        const cartCounter = doc.querySelector('#hidden_cart_count');
        const currentCartDrawer = document.getElementById('CartDrawer');
        const currentCartFooter = currentCartDrawer.querySelector('.cart-footer');

        if (!cartItems || !currentCartItems) {
          console.error("CartItems not found");
          return;
        }

        if (cartCounter) {
          const cartCount = parseFloat(cartCounter.value) || 0;
          let cartCountEl = document.querySelector('.js-cart-icon #cart-svg-count');
          let cartMobCountEl = document.querySelector('.js-cart-mobile-icon #mobile-cart-svg-count');

          if (cartCountEl) {
            cartCountEl.textContent = cartCount;
          } else {
            cartCountEl = document.createElement('div');
            cartCountEl.id = 'cart-svg-count';
            cartCountEl.className = 'cart-item-count w3_bg';
            cartCountEl.textContent = cartCount;
            const cartIcon = document.querySelector('.js-cart-icon');
            if (cartIcon) cartIcon.appendChild(cartCountEl);
          }

          if (cartMobCountEl) {
            cartMobCountEl.textContent = cartCount;
          } else {
            cartMobCountEl = document.createElement('div');
            cartMobCountEl.id = 'mobile-cart-svg-count';
            cartMobCountEl.className = 'cart-item-count';
            cartMobCountEl.textContent = cartCount;
            const cartMobIcon = document.querySelector('.js-cart-mobile-icon');
            if (cartMobIcon) cartMobIcon.appendChild(cartMobCountEl);
          }
        }

        currentCartItems.innerHTML = cartItems.innerHTML;
        currentCartFooter.innerHTML = cartFooter.innerHTML;

        // ── STEP 3: UI polish only — no quantity changes needed here
        setTimeout(() => {
          showSubProducts();
          updateDeliveryRemoveButtons();
        }, 300);

      })
      .catch((err) => {
        console.error("Section fetch error:", err);
      });
  }

  async function openCartDrawer() {
    await updateCart();
    drawer?.classList.remove("active", "is-active");
    overlay?.classList.remove("active", "is-active");
    drawer?.classList.add("active", "is-active");
    overlay?.classList.add("active", "is-active");
  }

  window.updateCart = updateCart;
  window.openCartDrawer = openCartDrawer;

  async function refreshCart() {
    fetch('/cart')
      .then(res => res.json())
      .catch((err) => {
        console.error("Cart fetch error:", err);
      });
  }

  window.refreshCart = refreshCart;

  function renderCart(cart) {
    let hiddenProducts = [];

    if (cart.item_count === 0) {
      cartItemsContainer.innerHTML = `<p class="empty-cart">Your cart is empty</p>`;
      cartTotal.innerHTML = Shopify.formatMoney(cart.total_price, window.Shopify.money_format);
      return;
    }

    let html = '';

    cart.items.forEach((item) => {
      const productType = item.product_type?.trim();
      const isHiddenProduct =
        productType === "OPTIONS_HIDDEN_PRODUCT" ||
        productType === "OPTIONS_HIDDEN_PRODUCTS";

      if (isHiddenProduct) hiddenProducts.push(item.product_title);

      html += `
        <div class="cart-item" data-key="${item.key}">
          <div class="cart-item-image">
            <img src="${item.image}" alt="${item.product_title}" width="80">
          </div>
          <div class="cart-item-details">
            <h4>${item.product_title}</h4>
            ${item.variant_title && item.variant_title !== 'Default Title'
              ? `<p class="cart-item-variant">Variant: ${item.variant_title}</p>`
              : ""}
            <p class="price">${Shopify.formatMoney(item.final_line_price, window.Shopify.money_format)}</p>
            <div class="item-quantity">Qty: ${item.quantity}</div>
          </div>
          <div class="item-actions">
            <button class="remove-btn" data-key="${item.key}">🗑</button>
          </div>
        </div>
      `;
    });

    cartItemsContainer.innerHTML = html;
    cartTotal.innerHTML = Shopify.formatMoney(cart.total_price, window.Shopify.money_format);

    if (hiddenProducts.length > 0) {
      alert("Restricted products:\n\n" + hiddenProducts.join("\n"));
    }

    checkAllItems(cart);
  }

  function checkAllItems(cart) {
    const domItems = document.querySelectorAll("#CartDrawer .cart-item");
    domItems.forEach((domItem, index) => {
      const apiItem = cart.items[index];
      if (!apiItem) return;
      const productType = apiItem.product_type?.trim();
      const qtyWrapper = domItem.querySelector(".item-quantity");
      if (productType === "OPTIONS_HIDDEN_PRODUCT" || productType === "OPTIONS_HIDDEN_PRODUCTS") {
        if (qtyWrapper) qtyWrapper.style.display = "none";
      } else {
        if (qtyWrapper) qtyWrapper.style.display = "block";
      }
    });
  }

  showSubProducts();
  updateDeliveryRemoveButtons();
});

/* =====================================
   FORM SUBMIT → OPEN DRAWER
===================================== */
document.addEventListener("submit", function (e) {
  const form = e.target;
  if (form.action && form.action.includes("/cart/add")) {
    setTimeout(function () {
      const drawer = document.getElementById("CartDrawer");
      const overlay = document.getElementById("CartOverlay");
      drawer?.classList.add("active", "is-active");
      overlay?.classList.add("active", "is-active");
    }, 1500);
  }
});

/* =====================================================
   LIMITED VARIANT QUANTITY ENFORCEMENT
   ===================================================== */

const LIMITED_VARIANT_IDS = [
  57642286350723, 57642264199555, 58097161994627, 58097162027395,
  58006245278083, 57642286317955, 58315118510467, 57897585672579,
  57897585705347, 57897585738115, 62695256850819, 62695256883587,
  62695256916355, 62683693547907, 62306697642371, 62306798502275,
  62306794963331, 62448224502147, 62448224534915, 62448224567683,
  58097161961859
];

const LIMITED_PARENT_PRODUCT_IDS = [
  7011044720738, 6964149387362, 6893008224354, 7051912773730, 7011126018146,7052130156642,7011029581922,
];

function isLimitedParentProduct(productId) {
  return LIMITED_PARENT_PRODUCT_IDS.includes(Number(productId));
}

function isLimitedVariant(variantId) {
  return LIMITED_VARIANT_IDS.includes(Number(variantId));
}

function getLimitedVariantQuantity(parentProductId, parentQuantity) {
  if (isLimitedParentProduct(parentProductId)) {
    return Math.ceil(Number(parentQuantity) / 3);
  }
  return 1;
}

/* =====================================================
   enforceLimitedVariant
   ─ skipCartReload: when true (called from inside
     updateCart) the function fixes quantities but does
     NOT call updateCart() again, breaking the loop.
   ─ When called standalone (drawer open, remove click,
     delivery click) skipCartReload is false, so it
     DOES call updateCart() once after fixing — but
     passes skipCartReload=true into that updateCart()
     call so the cycle stops there.
   ===================================================== */
async function enforceLimitedVariant(source = '', skipCartReload = false) {

  // // console.log('');
  // console.log('====================================');
  // console.log('🟢 LIMITED QUANTITY CHECK');
  // console.log('Source:', source);
  // console.log('Skip cart reload:', skipCartReload);
  // console.log('====================================');

  try {
    const response = await fetch('/cart.js', { credentials: 'same-origin' });

    if (!response.ok) {
      console.error('❌ Failed to get cart:', response.status);
      return;
    }

    const cart = await response.json();
    // console.log('🛒 Cart items:', cart.items.length);

    const updates = {};

    cart.items.forEach((item, index) => {
      const props = item.properties || {};

      // console.log('');
      // console.log('------------------------------------');
      // console.log('ITEM #' + (index + 1));
      // console.log('Product ID:', item.product_id);
      // console.log('Variant ID:', item.variant_id);
      // console.log('Quantity:', item.quantity);
      // console.log('Product:', item.product_title);
      // console.log('Variant:', item.variant_title);

      const isParentLine = !!props._accessoryVariantIds;
      // console.log('Is Parent:', isParentLine);

      if (isParentLine) {
        // console.log('⏭️ Parent item - skipping');
        return;
      }

      const groupId = props._accessoryGroupId;
      // console.log('Accessory Group ID:', groupId);

      if (!groupId) {
        // console.log('⏭️ No accessory group - skipping');
        return;
      }

      const parentItem = cart.items.find((parent) => {
        const parentProps = parent.properties || {};
        return (
          parentProps._accessoryGroupId === groupId &&
          !!parentProps._accessoryVariantIds
        );
      });

      if (!parentItem) {
        // console.log('❌ Parent not found for group:', groupId);
        return;
      }

      // console.log('👨 Parent Product ID:', parentItem.product_id);
      // console.log('👨 Parent Quantity:', parentItem.quantity);

      const variantMatched = isLimitedVariant(item.variant_id);
      // console.log('Child matches LIMITED_VARIANT_IDS:', variantMatched);

      if (!variantMatched) {
        // console.log('⏭️ Not a LIMITED_VARIANT_IDS item - skipping');
        return;
      }

      const parentMatched = isLimitedParentProduct(parentItem.product_id);
      // console.log('Parent matches LIMITED_PARENT_PRODUCT_IDS:', parentMatched);

      let desiredQuantity;

      if (parentMatched) {
        desiredQuantity = Math.ceil(Number(parentItem.quantity) / 3);
        // console.log('🟢 LIMITED PARENT RULE');
        // console.log('Calculation:', parentItem.quantity, '/ 3 =', desiredQuantity);
      } else {
        desiredQuantity = 1;
        // console.log('🟡 NORMAL PARENT RULE - max quantity = 1');
      }

      // console.log('📦 Current limited quantity:', item.quantity);
      // console.log('📦 Required limited quantity:', desiredQuantity);

      if (Number(item.quantity) !== Number(desiredQuantity)) {
        // console.log('🔴 QUANTITY NEEDS UPDATE:', item.quantity, '→', desiredQuantity);
        updates[item.key] = desiredQuantity;
      } else {
        // console.log('🟢 QUANTITY ALREADY CORRECT');
      }
    });

    if (Object.keys(updates).length === 0) {
      // console.log('');
      // console.log('✅ NO QUANTITY UPDATE REQUIRED');
      // console.log('====================================');
      return;  // quantities already correct — nothing to do, no reload needed
    }

    // console.log('');
    // console.log('🚀 UPDATING CART');
    // console.log('Updates:', updates);

    const updateResponse = await fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates }),
    });

    if (!updateResponse.ok) {
      console.error('❌ Cart update failed:', updateResponse.status);
      return;
    }

    const updatedCart = await updateResponse.json();
    // console.log('✅ CART UPDATED SUCCESSFULLY');

    // Only trigger a drawer refresh when called standalone.
    // When called from inside updateCart() (skipCartReload=true),
    // updateCart() will fetch the section HTML right after us
    // and the drawer will already show the corrected quantities.
    if (!skipCartReload && typeof window.updateCart === 'function') {
      // console.log('🔄 Refreshing cart drawer');
      await window.updateCart(true); // pass skipQtyEnforce=true to avoid recursion
    }

    // console.log('====================================');

  } catch (error) {
    console.error('❌ LIMITED QUANTITY ERROR:', error);
  }
}

/* =====================================================
   RUN CHECK AFTER DRAWER IS OPEN (standalone)
   ===================================================== */
function runLimitedVariantCheck(source = '') {
  // console.log('[qty-limit] 🔄 Check requested:', source);

  setTimeout(() => {
    const drawer = document.getElementById('CartDrawer');
    if (!drawer) {
      // console.log('[qty-limit] ❌ CartDrawer not found');
      return;
    }

    const drawerIsOpen =
      drawer.classList.contains('active') &&
      drawer.classList.contains('is-active');

    if (!drawerIsOpen) {
      // console.log('[qty-limit] ⏭️ Drawer is not open');
      return;
    }

    // console.log('[qty-limit] 🚀 Drawer is open');
    enforceLimitedVariant(source, false); // standalone — allowed to reload
  }, 500);
}

/* =====================================================
   CART DRAWER OPEN WATCHER
   ===================================================== */
document.addEventListener('DOMContentLoaded', function () {
  // console.log('[qty-limit] 🟢 Drawer watcher loaded');

  const drawer = document.getElementById('CartDrawer');
  if (!drawer) {
    // console.log('[qty-limit] ❌ CartDrawer not found');
    return;
  }

  let wasActive = false;

  function checkDrawerStatus() {
    const isActive =
      drawer.classList.contains('active') &&
      drawer.classList.contains('is-active');

    if (isActive && !wasActive) {
      // console.log('');
      // console.log('====================================');
      // console.log('🛒 CART DRAWER OPENED');
      // console.log('====================================');
      // Drawer open is already handled by updateCart() which
      // calls enforceLimitedVariant internally — no extra call needed here.
    }

    wasActive = isActive;
  }

  const observer = new MutationObserver(function () {
    checkDrawerStatus();
  });

  observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
  checkDrawerStatus();
});

/* =====================================================
   REMOVE BUTTON — quantity re-check after removal
   ===================================================== */
document.addEventListener('click', function (event) {
  const removeBtn = event.target.closest('.remove-btn');
  if (!removeBtn) return;

  // console.log('[qty-limit] 🗑️ REMOVE BUTTON CLICKED');

  // The remove handler above already calls updateCart() after ~400ms.
  // updateCart() now runs enforceLimitedVariant() internally before
  // rendering, so no separate call is needed here anymore.
});

/* =====================================================
   DELIVERY OPTION CHANGE — quantity re-check
   ===================================================== */
document.addEventListener('click', function (event) {
  const deliveryCard = event.target.closest(
    '.delivery-card, .delivery-option, [data-variant-id]'
  );
  if (!deliveryCard) return;

  // console.log('[qty-limit] 🚚 Delivery option clicked');

  setTimeout(function () {
    runLimitedVariantCheck('delivery option changed');
  }, 700);
});